import { render } from "./TaskTypeList.vue?vue&type=template&id=f4db6330"
import script from "./TaskTypeList.vue?vue&type=script&lang=js"
export * from "./TaskTypeList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__